import { useRuntimeConfig } from '.';

export const useRuntimeCommunity = () => {
  const { community } = useRuntimeConfig();
  return community;
};
